module.exports = {
	"articleTitle1": "Pieology pizzeria opens on East Liberty ",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Pieology",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/section/news-briefs/despite-pieology-mishap-students-have-no-trouble-finding-pies-pi-day",
	"articleSnippet1": "Aug 12, 2015 ... Pieology Pizzeria, which offers custom salads and pizzas with unlimited toppings, \nopened its doors at 620 East Liberty St. June 28. This is the ...",
	"articleSnippet2": "Mar 14, 2017 ... Pieology Pizzeria offered specially priced $3.14 pizzas at all ... of heavy student \ndemand for pies, Pieology ran out of dough and was forced to ...",
	"foodRecommendations": [
		{
			"text": "I am a huge fan of Pieology.",
			"person": "Charlie Ruiz"
		}
	],
	"articleTitle2": "On the Daily: Handing out pies on Pi Day, not as easy as pie ",
	"address": "620 E Liberty St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.279241,
		"lng": -83.741329
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/pieology.json
// module id = 946
// module chunks = 0